import {createFeatureSelector, createSelector} from "@ngrx/store";
import {TeamRegisterState} from "./team-register.state";

export const teamRegisterSelect = createFeatureSelector<TeamRegisterState>('teamRegister');

export const selectCurrentApp = createSelector(
  teamRegisterSelect,
  (state: TeamRegisterState) => state.currentApp
);

export const selectIsLoading = createSelector(
  teamRegisterSelect,
  (state: TeamRegisterState) => state?.isLoading
);
